<i18n>
zh: 
    desc: 捷能热力电站成立于2002年12月，注册资本5000万元，主要经营 范围为热力供应，是民营供热企业，主要承担黑龙江省内多处地市 的城市集中供热工作。公司总部位于黑龙江省哈尔滨市松北区热源路333号，在黑龙江牡丹江市和延寿县等地设有分公司， 总供热面积2406万平方米。
    more: 查看更多
    qrtext1: 缴费服务号
    qrtext2: 订阅号
    qrtext3: 宣传片
ru: 
    desc: ТЭС была создана в декабре 2002 года с уставным капиталом 50 млн. юаней, основной сферой деятельности является теплоснабжение, является частное теплоснабжение, в основном отвечает за централизованное городское отопление во многих городах и городах провинции Хэйлунцзян.  Штаб - квартира компании расположена на 333 - й улице теплового источника района Сунбэй города Харбин провинции Хэйлунцзян, имеет филиалы в городах Муданьцзян и Яньшоу провинции Хэйлунцзян, общая площадь отопления составляет 24,06 млн. квадратных метров.
    more: Проверь еще.
    qrtext1: Номер платной услуги
    qrtext2: Номер подписки
    qrtext3: Рекламные фильмы
</i18n>
<template>
    <div class="home">
        <Top/>
        <div class="logo"></div>
        <template v-if="config.menus && config.menus.length > 0">
            <Navigation type="index"/>
        </template>
        <swiper class="home_swiper" ref="swiper" :options="options">
            <swiper-slide>
                <div class="container">
                    <div class="l1">
                        <img src="@/assets/images/01_03.png" class="ani" swiper-animate-effect="fadeInLeft" swiper-animate-duration="1s" swiper-animate-delay="0.6s" alt=""/>
                        <img src="@/assets/images/01_04.png" class="ani" swiper-animate-effect="fadeInDown" swiper-animate-duration="0.5s" swiper-animate-delay="0.4s" alt=""/>
                        <div class="group">
                            <img src="@/assets/images/01_05.png" class="ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s" swiper-animate-delay="0.8s" alt=""/>
                            <img src="@/assets/images/01_07.png" class="ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s" swiper-animate-delay="1s" alt=""/>
                            <img src="@/assets/images/01_08.png" class="ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s" swiper-animate-delay="1.2s" alt=""/>
                            <img src="@/assets/images/01_09.png" class="ani" swiper-animate-effect="fadeInRight" swiper-animate-duration="1s" swiper-animate-delay="1.4s" alt=""/>
                        </div>
                    </div>
                </div>
                <div class="bg" :style="`background-image: url(${bg[0]});`"></div>
            </swiper-slide>
            <swiper-slide>
                <div class="container">
                    <div class="l2">
                        <div class="l2_01 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s" swiper-animate-delay="0.2s">{{$t('desc')}}</div>
                        <img src="@/assets/images/about.jpg" alt="" class="l2_02 ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s" swiper-animate-delay="0.4s">
                        <div class="l2_btn ani" swiper-animate-effect="fadeInUp" swiper-animate-duration="0.5s" swiper-animate-delay="0.6s">
                            <router-link to="/detail/2">{{$t('more')}}</router-link>
                        </div>
                    </div>
                </div>
                <div class="bg" :style="`background-image: url(${bg[1]});`"></div>
            </swiper-slide>
            <swiper-slide>
                <div class="bg" :style="`background-image: url(${bg[2]});`"></div>
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
        </swiper>
        <div class="bottom">
            <div class="l">
                <p>{{config.address}}</p>
                <p>{{config.phone}}</p>
                <p>Copyright(C) www.jienengredian.com All Rights Reserved</p>
                <p>备案号: 黑ICP备19000544号-1</p>
            </div>
            <div class="r">
                <div class="qrbox">
                    <img src="@/assets/images/8_50.jpg" alt="" class="qrcode">
                    <p>{{$t('qrtext1')}}</p>
                </div>
                <div class="qrbox">
                    <img src="@/assets/images/8_20.jpg" alt="" class="qrcode">
                    <p>{{$t('qrtext2')}}</p>
                </div>
                <router-link class="qrbox" to="/list/10/detail/78">
                    <img src="@/assets/images/1.png" alt="" class="qrcode">
                    <p>{{$t('qrtext3')}}</p>
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import '@/assets/css/animate.min.css';
import swiperAnimate from '@/assets/js/swiper.animate1.0.3.min.js';
import { swiper, swiperSlide } from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import Top from './top.vue';
import Navigation from './navigation.vue';
export default {
    name: "homePC",
    data() {
        return {
            bg: [
                require('@/assets/images/bg01.jpg'),
                require('@/assets/images/bg02.jpg'),
                require('@/assets/images/bg03.jpg'),
            ],
            options: {
                resistanceRatio: 0,
                observer: true,
                observeParents: true,
                pagination: {
                    el: '.swiper-pagination',
                },
                direction: 'vertical',
                simulateTouch: false,
                mousewheel: true,
                on: {
                    init: function(){
                        swiperAnimate.swiperAnimateCache(this); //隐藏动画元素 
                        swiperAnimate.swiperAnimate(this); //初始化完成开始动画
                    }, 
                    slideChangeTransitionEnd: function(){ 
                        swiperAnimate.swiperAnimate(this); //每个slide切换结束时也运行当前slide动画
                        //this.slides.eq(this.activeIndex).find('.ani').removeClass('ani'); 动画只展现一次，去除ani类名
                    } 
                }
            },
        };
    },
    computed: {
        ...mapState(['config']),
        swiper() {
            return this.$refs.swiper.$swiper
        },
    },
    components: {
        swiper,
        swiperSlide,
        Top,
        Navigation,
        
    },
    mounted() {
        
    },
    destroyed() {},
    watch: {},
    methods: {
        
    },
};
</script>

<style scoped lang="scss">
.logo{
    width: 100px;
    height: 100px;
    background: url('~@/assets/images/logo.png') no-repeat center/100%;
    position: absolute;
    top: 30px;
    left: 10%;
    z-index: 2;
}
.home{
    position: absolute;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
}
.home_swiper{
    flex: 1;
    width: 100%;
    .swiper-slide{
        overflow: hidden;
    }
    .bg{
        width: 100%;
        height: 100%;
        background-size: cover;
        background-position: center;
        animation: pagebgfd 10s infinite alternate both;
        @keyframes pagebgfd{
            0% { transform:scale(1.3); }
            100% { transform:scale(1); };
        }
    }
    .container{
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
    }
    .l1{
        display: flex;
    }
    .l2{
        width: 500px;
        .l2_01{
            color: #fff;
            text-align: justify;
        }
        .l2_02{
            margin: 20px 0;
        }
        .l2_btn{
            a{
                text-align: center;
                border-radius: 5px;
                display: inline-block;
                width: 150px;
                height: 40px;
                line-height: 40px;
                background-color: #1677cb;
                color: #ffffff;
            }
        }
    }
}
.bottom{
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    color: #fff;
    .l{
        margin-left: 5%;
        margin-bottom: 20px;
        font-size: 14px;
        line-height: 2;
        color: #fff;
        padding-left: 10px;
    }
    .r{
        display: flex;
        margin-right: 5%;
        .qrbox{
            margin-left: 20px;
            text-align: center;
            font-size: 14px;
            line-height: 3;
            .qrcode{
                width: 70px;
                border: 4px solid #fff;
                box-sizing: content-box;
                margin: 0 auto;
            }
        }
    }
}
</style>